import React from 'react';

export default {
  banner: {
    title: 'Gator Protect',
    description: 'Powered by Monarx AI',
    selectPlanLabel: 'Confira a proteção da hospedagem para:',
    mainDomain: 'domínio principal:',
    proBadgeLabel: 'PRO',
    img: {
      alt: 'Snappy Monarx',
    },
  },
  summary: {
    threatsIdentified: 'Ameaças identificadas',
    threatsRemediated: 'Ameaças eliminadas',
    keepProtected: 'Mantenha seu site protegido!',
    keepProtectedDescription: 'Não espere o período de teste da proteção completa acabar. Mantenha a proteção e fique tranquilo!',
    keepProtectionActive: 'Manter proteção ativa',
    withoutLastScan: {
      title: 'Aguardando a primeira varredura',
      description: 'Seu site está em monitoramento constante, as ameaças identificadas serão listadas aqui.',
    },
    enableYourProtection: (
      <>
        Não deixe seu site vulnerável.
        <br/>
        Ative a remoção automática de ameaças.
      </>
    ),
    protectionCard: {
      trialIsActive: {
        title: 'Continue seguro sem interrupções',
        description: 'Durante o período de teste, o Gator Protect Pro protege seu site contra ameaças reais, de forma automática.',
        actions: [
          {
            key: 'activateProtectionPro',
            label: 'Manter proteção ativa',
            variant: 'primary',
          },
        ],
      },
      automaticProtectionAvailable: {
        title: 'Proteção automática disponível',
        description: 'Ative agora para remover as ameaças identificadas automaticamente.',
        activateProtectionPro: {
          key: 'activateProtectionPro',
          label: 'Ativar Proteção Pro',
          variant: 'secondary',
        },
        activateTrial: {
          regular: {
            key: 'activateTrial',
            label: 'Testar 30 dias grátis',
            variant: 'primary',
          },
          aa: {
            key: 'activateTrial',
            label: 'Testar 1 ano grátis',
            variant: 'primary',
          },
        },
      },
      safeWithoutInterruption: {
        title: 'Continue seguro sem interrupções.',
        description: 'Durante o período de teste, o Gator Protect Pro já protege seu site contra ameaças reais, de forma automática.',
        actions: [
          {
            key: 'keepProtectionActive',
            label: 'Manter proteção ativa',
            variant: 'primary',
          },
        ],
      },
      pendingInvoice: {
        title: 'Sua proteção está quase ativa!',
        description: 'Finalize o pagamento na aba "Faturas" para ativar o serviço.',
        goToInvoices: 'Ir para Faturas',
      },
      upgradeCycle: {
        getTitle: fromAnnualHosting => (
          fromAnnualHosting
            ? 'Garanta proteção por 3 anos com desconto'
            : 'Garanta proteção pelo ano inteiro com desconto'
        ),
        getDescriptionHtml: (percent, fromAnnualHosting) => (
          fromAnnualHosting
            ? `Mude para o plano trienal agora e economize <strong>${percent}% na assinatura</strong>, o equivalente a quase 2 meses grátis.`
            : `Mude para o plano anual agora e economize <strong>${percent}% na assinatura</strong>, o equivalente a quase 2 meses grátis.`
        ),
        getActionLabel: (percent, fromAnnualHosting) => (
          fromAnnualHosting
            ? `Assinar plano trienal com ${percent}% de desconto`
            : `Assinar plano anual com ${percent}% de desconto`
        ),
      },
    },
    upgradeCycleModal: {
      title: 'Garanta proteção pelo ano inteiro com desconto',
      getSubtitleLeading: (cycleKey) => {
        if (cycleKey === 'monthly') {
          return 'No plano mensal, você paga ';
        }
        if (cycleKey === 'triennially') {
          return 'No plano trienal, você ';
        }
        return 'No plano anual, você paga ';
      },
      getSubtitleEmphasis: (cycleKey, percent) => {
        if (cycleKey === 'annually') {
          return `10 meses e fica protegido por 12, são ${percent}% de desconto.`;
        }
        return `economiza ${percent}% na assinatura.`;
      },
      featureItems: [
        'Remoção automática de ameaças',
        'Evita perda de dados e interrupções no site',
        'Protege contra invasões, quedas e ataques',
        'Proteção ativa 24h com monitoramento',
      ],
      paymentCycleLabel: 'Ciclo de pagamento',
      selectCyclePlaceholder: 'Selecione o ciclo',
      paymentCycleLabelMonthly: 'Mensal',
      paymentCycleLabelAnnual: 'Anual',
      paymentCycleLabelTriennial: 'Trienal',
      bestOptionSuffix: 'Melhor opção',
      getDiscountBadge: percent => `${percent}% Off`,
      termsPrefix: 'Ao ativar, você concorda com os ',
      termsLink: 'Termos e Condições',
      getCtaLabel: (cycleKey, formattedPrice) => {
        if (cycleKey === 'monthly') {
          return `Ativar por ${formattedPrice}/mês`;
        }
        if (cycleKey === 'triennially') {
          return `Ativar plano trienal por ${formattedPrice}`;
        }
        return `Ativar pelo ano inteiro por ${formattedPrice}`;
      },
      refundNote: 'Até 30 dias para reembolso',
      fromAnnualHosting: {
        title: 'Garanta proteção por 3 anos com desconto',
        getSubtitleLeading: (cycleKey) => {
          if (cycleKey === 'monthly') {
            return 'No plano mensal, você paga ';
          }
          return 'No plano trienal, você ';
        },
        getSubtitleEmphasis: (cycleKey, percent) => {
          if (cycleKey === 'triennially') {
            return `economiza ${percent}% na assinatura e mantém a proteção por 3 anos.`;
          }
          return `economiza ${percent}% na assinatura.`;
        },
        getCtaLabel: (cycleKey, formattedPrice) => {
          if (cycleKey === 'monthly') {
            return `Ativar por ${formattedPrice}/mês`;
          }
          return `Ativar plano trienal por ${formattedPrice}`;
        },
      },
    },
    protectionModal: {
      common: {
        productTitle: 'Gator Protect',
        productSubtitle: 'Powered by Monarx AI',
        proBadgeLabel: 'PRO',
        checklistItems: [
          'Remoção automática de ameaças',
          'Evita perda de dados e interrupções no site',
          'Protege contra invasões, quedas e ataques',
          'Proteção ativa 24h com monitoramento',
        ],
      },
      trialActivation: {
        title: isAa => `Ative agora e não pague nada por ${isAa ? '1 ano' : '30 dias'}`,
        subtitle: price => `Após o período gratuito, assine por apenas ${price} por mês`,
        buttonLabel: 'Ativar teste gratuito',
      },
      trialActive: {
        title: 'Continue com a proteção completa ativa',
        subtitle: 'Após o período de teste, a remoção automática será desativada.',
        message: daysLeft => (daysLeft >= 0 ? `Seu teste encerra em ${daysLeft} dias.` : ''),
        buttonLabel: price => `Ativar agora por ${price}/mês`,
      },
      proActivation: {
        title: 'Seu site pode estar vulnerável agora',
        subtitle: 'Ative o Gator Protect PRO e evite invasões, quedas e perda de dados automaticamente.',
        buttonLabel: price => (price ? `Ativar agora por ${price}/mês` : 'Ativar proteção Pro'),
      },
    },
    automaticCleaningConsentModal: {
      title: 'Confirme a limpeza automática',
      description: 'Autorizo a remoção dos arquivos infectados e estou ciente de que o processo pode causar perda de páginas ou impactar o funcionamento do site. Não responsabilizo o suporte da HostGator por este processo.',
      checkboxLabel: 'Li e aceito',
      cancelButtonLabel: 'Cancelar',
      confirmButtonLabel: 'Iniciar limpeza',
    },
    alerts: {
      fullProtectionActive: (
        <>
          <strong>Proteção completa ativa.</strong>
          {' Seu site sempre seguro!'}
        </>
      ),
      cleaningInProgress: 'Sua limpeza está em andamento. Aguarde até 24h para realizar uma nova solicitação.',
      expiredProtection: 'A proteção do seu site acabou. Não deixe seu site vulnerável a ameaças.',
      trialActive: daysLeft => (
        <>
          <strong>Seu período de teste está ativo.</strong>
          {' Seu site está protegido por mais '}
          <strong>{`${daysLeft} dias!`}</strong>
        </>
      ),
      teamIntervention: {
        title: threatsNumber => `Você tem ${threatsNumber} ameaças que precisam de intervenção da nossa equipe!`,
        description: 'Para que a equipe continue a análise e o tratamento, é preciso abrir um chamado.',
        buttonLabel: 'Abrir chamado',
      },
      teamInterventionResolved: {
        title: 'A ameaça foi analisada e eliminada pela nossa equipe',
        description: 'Sua hospedagem continua protegida com monitoramento automático de novas ameaças.',
        buttonLabel: 'Acessar chamado',
      },
    },
    automaticRemovalToggle: {
      automaticRemovalLabel: isActive => (
        <>
          {'Remoção automática de ameaças '}
          <strong>{isActive ? 'ativada' : 'desativada'}</strong>
        </>
      ),
      automaticRemovalTooltip: 'Quando ativado, o sistema identifica e remove automaticamente ameaças no seu site.',
      lastVerification: ({ hour, day }) => (
        <>
          <strong>Monitoramento constante. Ultima verificação:</strong>
          {` ${day} às ${hour}`}
        </>
      ),
      noData: 'Aguardando primeira varredura',
    },
  },
  threatsTable: {
    columns: {
      file: 'Arquivo',
      threat: 'Ameaça',
      situation: 'Situação',
      detectedAt: 'Data de identificação',
    },
    situationTags: {
      quarantine: 'Ameaça não removida',
      remediated: 'Eliminada',
    },
    header: {
      exportButtonAriaLabel: 'Exportar',
      infoPlaceholder: 'Últimos 30 dias',
    },
    tags: {
      detected: 'Ameaça não removida',
      remediated: 'Eliminada',
    },
  },
  activitiesChart: {
    title: 'Ameaças identificadas',
    titleInfoTooltip: 'São arquivos maliciosos que podem ameaçar a segurança do seu site.',
    filter: {
      last30Days: 'Últimos 30 dias',
    },
    compromisedFilesLabel: 'Arquivos comprometidos',
    maliciousCodesLabel: 'Arquivos maliciosos',
    emptyTitle: 'Nenhuma atividade',
    emptyImageAlt: 'Nenhuma atividade',
    emptyDescription: 'Nenhuma ameaça identificada ou arquivos suspeitos nos últimos 30 dias.',
  },
  terms: {
    label: 'Li e aceito os ',
    cta: 'Termos e Condições',
  },
  acknowledgedModal: {
    title: {
      trial: ({ days }) => `Teste grátis por ${days} dias · Ativo`,
      pro: ({ plan }) => `Proteção Pro ativa · incluída no seu plano ${plan}`,
    },
    secondTitle: {
      trial: ({ days }) => `Você ganhou ${days} dias grátis de proteção automática!`,
      pro: 'Seu site agora tem proteção automática',
    },
    description: {
      trial: (
        <>
          {'Ativamos o '}
          <strong>Gator Protect Pro</strong>
          {' seu site protegido contra invasões e ameaças.'}
        </>
      ),
      pro: (
        <>
          {'O '}
          <strong>Gator Protect Pro</strong>
          {' já está ativo e cuidando da segurança do seu site sem você precisar fazer nada.'}
        </>
      ),
    },
    perksTitle: 'Seu site seguro sempre:',
    perks: [
      'Monitoramento contínuo',
      'Remoção automática de ameaças',
    ],
    cta: {
      trial: 'Quero manter a proteção',
      pro: 'Acessar Gator Protect',
    },
    additionalInfo: {
      trial: 'Ao final do teste grátis, você decide se quer continuar:sem renovação automática de ameaças e sem cobrança.',
      pro: 'Gerencie ou ajuste a proteção do seu site a qualquer momento. Este recurso já está incluso no seu plano Turbo, sem custo adicional.',
    },
  },
  detectedThreadsModal: {
    productTitle: 'Gator Protect',
    productSubtitle: 'Powered by Monarx AI',
    headline: 'Seu site precisa de proteção',
    bodyPrefix: 'Identificamos ',
    threatsBold: ({ count }) => (count === 1 ? '1 ameaça' : `${count} ameaças`),
    bodySuffixLine1: ' no seu site.',
    bodyLine2: 'Ative o Gator Protect para manter tudo seguro.',
    primaryCta: 'Resolver ameaças agora',
    shieldImageAlt: 'Gator Protect powered by Monarx',
  },
  noThreatsModal: {
    productTitle: 'Gator Protect',
    productSubtitle: 'Powered by Monarx AI',
    headlineLead: '+30.000 sites',
    headlineRest: ' são hackeados todos os dias. Proteja o seu',
    features: [
      {
        title: 'Detecta ameaças antes que prejudiquem seu site',
        description: 'Monitoramento contínuo de todos os arquivos do seu site',
      },
      {
        title: 'Remove vírus automaticamente, sem você fazer nada',
        description: 'Remoção imediata de arquivos infectados ao ativar',
      },
      {
        title: 'Proteção ativa 24h por dia',
        description: 'Seu site seguro o tempo inteiro.',
      },
    ],
    primaryCta: 'Proteger meu site agora',
    pricingFootnote: ({ price }) => `A partir de ${price}/mês. Cancele quando quiser`,
    shieldImageAlt: 'Gator Protect powered by Monarx',
  },
  insideProductDetail: {
    tag: 'PRO',
    title: 'Gator Protect',
    isNotTurbo: {
      isFree: {
        firstRow: 'Seu site em risco. O monitoramento do seu site está ativo, mas as ameaças não são removidas automaticamente.',
        secondRow: days => (
          <>
            {'Ative a remoção automática de ameaças. Faça o '}
            <strong>
              {'teste gratuito por '}
              {days}
              {' dias.'}
            </strong>
          </>
        ),
        cta: 'Acessar proteção',
      },
      isPro: {
        withoutScan: {
          firstRow: (
            <>
              {'Seu site tem proteção completa no seu plano, mas a '}
              <strong>remoção automática de ameaças</strong>
              {' ainda não está ativa.'}
            </>
          ),
          secondRow: 'Ative agora e não corra o risco de instabilidade, alterações e bloqueios.',
          cta: 'Ir para ativação automática',
        },
        withScan: {
          firstRow: (
            <>
              {'Seu '}
              <strong>site está com proteção completa:</strong>
              {' monitoramento contínuo e remoção automática de ameaças. Mais segurança e estabilidade.'}
            </>
          ),
          cta: 'Acessar proteção',
          variant: 'secondary',
        },
      },
    },
    isTurbo: {
      isFree: {
        firstRow: (
          <>
            {'Você já tem acesso à proteção completa, '}
            <strong>sem custo adicional</strong>
            , mas a remoção automática de ameaças ainda não está ativa.
          </>
        ),
        secondRow: 'Ative agora para manter seu site protegido sempre.',
        cta: 'Acessar proteção',
      },
      isPro: {
        withoutScan: {
          firstRow: (
            <>
              {'Seu site tem proteção completa no seu plano,a '}
              <strong>remoção automática de ameaças</strong>
              {' ainda não está ativa.'}
            </>
          ),
          secondRow: 'Ative agora e não corra o risco de instabilidade, alterações e bloqueios.',
          cta: 'Ir para ativação automática',
        },
        withScan: {
          firstRow: (
            <>
              {'Seu '}
              <strong>site está com proteção completa:</strong>
              {' monitoramento contínuo e remoção automática de ameaças. Mais segurança e estabilidade.'}
            </>
          ),
          cta: 'Acessar proteção',
          variant: 'secondary',
        },
      },
    },
    isTrial: {
      firstRow: (
        <>
          <strong>Proteção completa ativa (teste gratuito)</strong>
          . Seus sites contam com monitoramento contínuo e remoção automática de ameaças.
        </>
      ),
      secondRow: 'Aproveite o período de teste para conhecer todos os benefícios.',
      cta: 'Acessar benefícios',
      variant: 'secondary',
    },
    isExpired: {
      firstRow: (
        <>
          <strong>Seu site está exposto.</strong>
          {'  O teste gratuito terminou e a proteção completa e a remoção automática de ameaças não estão mais ativas.'}
        </>
      ),
      secondRow: 'Ative porque um ataque pode tirar seu site do ar.',
      cta: 'Acessar proteção',
    },
  },
  migrateToGatorProtectModal: {
    title: 'Proteção total e automática com o novo Gator Protect',
    description: (
      <>
        {'Atualizamos sua proteção para garantir sites mais seguros e rápidos. '}
        <strong>Ative a versão pro e tenha remoção automática de malwares e muito mais.</strong>
      </>
    ),
    light: {
      title: 'Proteção básica',
      list: [
        'Monitoramento de ameaças',
      ],
      cta: 'Continuar com Plano Light',
    },
    pro: {
      title: 'Proteção completa e automática',
      list: [
        'Remoção automática de ameaças',
        'Evita perda de dados e interrupções no site',
        'Protege contra invasões, quedas e ataques',
        'Proteção ativa 24h com monitoramento',
      ],
      cta: price => `Ativar agora por ${price}/mês`,
      terms: 'Ao ativar, você concorda com os ',
      termsCta: 'Termos e Condições',
    },
  },
};
